export default __webpack_public_path__ + "static/portfolio-supermanager-2f69136d3d9722c93acd9730aa592049.png";